<template>
    <div class="cropper-upload">
        <div class="cropper-wrap">
            <img v-if="imageData" class="image" ref="image" :src="imageData">
            <p v-else class="no-data-tips">请选择图片,只能上传jpg/png文件；不支持png24/gif格式。</p>
        </div>
        <div class="control-wrap">
            <el-upload
                class="fe-upload"
                action=""
                name="fe_upload"
                :http-request="selectFileHandler"
                :show-file-list="false">
                <el-button size="mini" type="primary">选择图片</el-button>
            </el-upload>
            <el-button-group
                v-if="imageData">
                <el-button
                    size="mini"
                    @click="rotateImage(-90)" title="逆时针旋转">-90°</el-button>
                <el-button
                    size="mini"
                    @click="rotateImage(90)" title="顺时针旋转">+90°</el-button>
                <el-button
                    size="mini"
                    @click="zoomImage(-0.1)"
                    icon="el-icon-zoom-in" title="缩小图片"></el-button>
                <el-button
                    size="mini"
                    @click="zoomImage(0.1)"
                    icon="el-icon-zoom-out" title="放大图片"></el-button>

                <el-button
                    size="mini"
                    @click="cropperBoxChange(1000)" title="裁剪窗放大到100%">100%</el-button>
                <el-button
                    size="mini"
                    @click="resetCropper"
                    icon="el-icon-refresh" title="重置"></el-button>
                <el-button
                    size="mini"
                    @click="priviewCropper" title="预览裁剪图片">预览</el-button>
            </el-button-group>
            <el-button
                v-if="imageData"
                class="upload-btn"
                type="primary"
                size="mini"
                icon="el-icon-upload"
                title="上传裁剪后的图片"
                @click="uploadHandler"></el-button>
        </div>

        <el-dialog title="预览" width="500px" :visible.sync="previewShow" append-to-body>
            <div class="preview-wrap">
                <img class="preview-dom" :src="previewData">
            </div>
        </el-dialog>

        <p v-if="!supportFileReader" class="no-support-filereader">抱歉，您的浏览器不支持该功能。<br/>建议使用最新版本的chrome浏览器。</p>
    </div>
</template>
<script>
    import Cropper from 'cropperjs';
    import 'cropperjs/dist/cropper.css';

    export default {
        data() {
            return {
                imageData: '',
                cropper: null,
                previewData: '',
                previewShow: false,
                supportFileReader: typeof FileReader === 'function'
            }
        },
        components: {
        },
        methods: {
            selectFileHandler({file}) {
                // 文件类型验证
                if (
                    file.type.search('png') === -1
                    && file.type.search('jpg') === -1
                    && file.type.search('jpeg') === -1
                ) {
                    this.$message({
                        type: 'warning',
                        message: `只能上传jpg/png文件`,
                        duration: 1500
                    });
                    return;
                }
                let reader = new FileReader();
                reader.onload = () => {
                    let url = reader.result;
                    this.imageData = url;
                    this.initCropper();
                };
                reader.readAsDataURL(file);
            },
            uploadHandler() {
                let cropperCanvas = this.cropper.getCroppedCanvas();
                if (!cropperCanvas.toBlob) {
                    this.$message({
                        type: 'warning',
                        message: `抱歉，您的浏览器不支持该功能。建议使用最新版本的chrome浏览器。`,
                        duration: 3000
                    });
                    return;
                }
                cropperCanvas.toBlob((blob) => {
                    // 自定义上传
                    this.$emit('upload-handler', blob);
                }, 'image/jpeg', 0.8);
            },
            priviewCropper() {
                let cropperCanvas = this.cropper.getCroppedCanvas();
                let base64url = cropperCanvas.toDataURL('image/jpeg');
                this.previewData = base64url;
                this.previewShow = true;
            },
            rotateImage(deg) {
                this.cropper.rotate(deg);
            },
            cropperBoxChange(size) {
                this.cropper.setCropBoxData({
                    left: 0,
                    top: 0,
                    width: 1000,
                    height: 1000
                });
            },
            resetCropper() {
                this.cropper.reset();
                this.cropperBoxChange();
            },
            zoomImage(size) {
                this.cropper.zoom(size);
            },
            initCropper() {
                if (this.cropper && this.cropper.destroy) {
                    this.cropper.destroy();
                }
                setTimeout(() => {
                    this.cropper = new Cropper(this.$refs['image'], {
                        aspectRatio: NaN,
                        viewMode: 2,
                        crop: function (e) {
                        },
                        ready: () => {
                            this.cropperBoxChange();
                        }
                    });
                }, 100);
            }
        },
        mounted() {

        }
    }
</script>
<style lang="less">
    .cropper-upload {
        width: 500px;
        position: relative;
        .no-support-filereader {
            position: absolute;
            z-index: 10;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-color: rgba(255,255,255,0.9);
            padding-top: 130px;
            text-align: center;
            font-size: 16px;
            color: #333;
        }
        .fe-upload {
            display: inline-block;
            vertical-align: top;
        }
        .no-data-tips {
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.2);
            line-height: 300px;
            font-size: 16px;
            color: #333;
            text-align: center;
        }
        .image {
            max-width: 100%;
        }
        .cropper-wrap {
            width: 500px;
            height: 400px;
        }
        .control-wrap {
            padding-top: 5px;
            overflow: hidden;
            .el-button {
                vertical-align: top;
                margin-left: 0;
                height: 28px;
            }
            .select-btn {
                margin-right: 5px;
            }
            .upload-btn {
                float: right;
            }
            .el-button-group {
                vertical-align: top;
            }
        }
        .preview-wrap {
            max-height: 600px;
            overflow-y: auto;
            box-shadow: 0px 0px 3px 3px rgba(0,0,0,0.1);
        }
        .preview-dom {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/uploadImage/cropperUpload.vue